<template>
	<div :class="['product-list', 'el-'+details.id, advanced.cssClasses, responsiveClasses]"
	     :id="advanced.cssId||details.id" :style="blockStyle"
				:data-selecta="localData.selecta">
		<div class="pl-header" :style="labelStyle">
			<div class="editable_wrpr" v-for="(item, index) in localData.headerTitles">
        <span>
            {{ item }}
        </span>
			</div>
		</div>

		<div class="pl-items" :style="style" :data-type="basic.selectionType">
		</div>
	</div>
</template>

<script>
import InputNumber from "@/modules/page-editor/src/components/sidebar/sidebar-items/InputNumber.vue"
import {mapGetters} from "vuex"
import {borderProps, boxShadow, fontProps, getPadding, textDecoration} from "@/modules/page-editor/src/utils/props";

export default {
	name: 'EmailProductList',
	components: {
		InputNumber,
	},
	props: ['id', 'addedClass', 'details'],
	data() {
		return {
			// localData: {},
			defData: {
				selecta:'Select a',
				headerTitles: [
					'Product',
					'Price',
				],
			}
		}
	},
	computed: {
		...mapGetters(['page_findOne', 'page_findChild']),
		content() {
			return this.details;
		},
		basic() {
			return this.details.attributes.basic
		},
		advanced() {
			return this.details.attributes.advanced
		},
		localData(){
			return this.content.content ? this.content.content : this.defData;
		},
		responsive() {
			return this.details.responsive
		},
		responsiveClasses() {
			let c = '';
			if (!this.responsive) return '';
			if (!this.responsive.desktop) c = 'no-desktop';
			if (!this.responsive.mobile) c += ' no-mobile';
			if (!this.responsive.tablets) c += ' no-tablet';
			return c;
		},
		labelStyle() {
			return {
				...fontProps(this.basic.labelFont),
			}
		},
		blockStyle() {
			return {
				...borderProps(this.basic.border),
				margin: getPadding(this.basic.margin),
				padding: getPadding(this.advanced.padding),
				boxShadow: boxShadow(this.basic.shadows),
				backgroundColor: this.basic.backgroundColor,
			};
		},
		style() {
			return {
				...fontProps(this.basic.font),
			}
		}
	},
	methods: {
	},
	created() {
		// this.localData = this.content.content ? this.content.content : this.defData;
	}
}
</script>
